import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import PwdIcon from "../../assets/icons/pwd-icon.png";
import UserIcon from "../../assets/icons/user-icon.png";
import Logo from "../../assets/images/logo.png";
import {
	LoginAction,
	LoginTwoFactorAction,
} from "../../redux/actions/user-action-types";
import {
	xhrApiSendAuth2faSetupEmail,
	xhrApiValidateAuth2faKey,
} from "../../utilities/xhr-api";
import Slider from "./slider";
import LoginSliderPanel from "../../components/sections/LoginSliderPanel";
import { LOGIN_SLIDER } from "../../utilities/loginSliderConfig";

// const Login = () => {
// 	const dispatch = useDispatch();
// 	const history = useHistory();

// 	const [username, setUsername] = React.useState("");
// 	const [password, setPassword] = React.useState("");
// 	const [tempSessionToken, setTempSessionToken] = React.useState("");
// 	const [temp2faKey, setTemp2faKey] = React.useState("");
// 	const [show2faHelp, setShow2faHelp] = React.useState(false);
// 	const [isLoading, setIsLoading] = React.useState(false);
// 	const [showPassword, setShowPassword] = React.useState(false);
// 	const send2faCodeEmail = async () => {
// 		var res = await xhrApiSendAuth2faSetupEmail(tempSessionToken);
// 	};

// 	React.useEffect(() => {
// 		if (tempSessionToken?.length > 0) {
// 			//	send2faCodeEmail(tempSessionToken);
// 		}
// 	}, [tempSessionToken]);

// 	const validate2fa = async (e) => {
// 		e.preventDefault();
// 		setIsLoading(true);
// 		var res = await xhrApiValidateAuth2faKey(tempSessionToken, temp2faKey);
// 		if (res?.result?.data) {
// 			dispatch(
// 				LoginTwoFactorAction({
// 					token: res?.result?.data,
// 					tokenExpireDate: res?.result?.expireDate,
// 					callback: (data) => {
// 						setIsLoading(false);
// 						if (history.length > 0) {
// 							history.goBack();
// 						} else {
// 							window.location.reload();
// 						}
// 					},
// 				}),
// 			);
// 		}
// 	};

// 	const onSubmit = async (e) => {
// 		e.preventDefault();
// 		setIsLoading(true);
// 		dispatch(
// 			LoginAction({
// 				userName: username,
// 				password,
// 				history,
// 				callback: (data) => {
// 					setIsLoading(false);
// 					if (data?.error) {
// 					} else if (data?.result?.status === "RequireEmailConfirm") {
// 						history.push("/account/email-confirm");
// 					} else if (data?.result?.status === "Require2fa") {
// 						setTempSessionToken(data?.result?.data);
// 					}
// 				},
// 			}),
// 		);
// 	};

// 	return (
// 		<div>
// 			<div className="prospect-combo">
// 				<div className="container-fluid p-0">
// 					<div className="row m-0">
// 						<div
// 							className="col-xl-4 col-lg-5 col-md-6 col-sm-12 sign-left d-flex flex-column align-content-center justify-content-center"
// 							style={{ textAlign: "center" }}
// 						>
// 							<div style={{ flex: "1" }}></div>
// 							<div>
// 								<label style={{ fontFamily: "monospace", fontSize: "60px" }}>
// 									<span style={{ color: "white" }}>Ref</span>
// 									<span style={{ color: "#e78e4b" }}>App</span>
// 								</label>
// 							</div>
// 							<div style={{ flex: "1" }}></div>
// 							<div>
// 								<img
// 									style={{
// 										position: "relative",
// 										marginLeft: "80%",
// 										width: "16%",
// 									}}
// 									src={Logo}
// 									alt="CoolBrand"
// 									className="loginLogoStyle"
// 								/>
// 							</div>
// 						</div>
// 						<div className="col-xl-8 col-lg-7 col-md-6 col-sm-12 form-element  px-sm-5 pt-sm-5 d-flex flex-column align-content-center justify-content-center form-container">
// 							{(tempSessionToken?.length ?? 0) === 0 && (
// 								<>
// 									<h3 className="form-heading mb-5">Login to your account</h3>
// 									<form onSubmit={onSubmit}>
// 										<div className="input-group mb-4">
// 											<div className="input-group-prepend">
// 												<span className="input-group-text">
// 													<img src={UserIcon} alt="usericon" />
// 												</span>
// 											</div>
// 											<input
// 												type="text"
// 												className="form-control"
// 												placeholder="User name"
// 												id="userNameLogin"
// 												name="usernameLogin"
// 												onChange={async (e) => setUsername(e.target.value)}
// 											/>
// 										</div>
// 										<div className="input-group mb-4">
// 											<div className="input-group-prepend">
// 												<span className="input-group-text">
// 													<img src={PwdIcon} alt="pwdicon" />
// 												</span>
// 											</div>

// 											<input
// 												type={showPassword ? "text" : "password"}
// 												className="form-control"
// 												placeholder="Enter password"
// 												id="passwordLogin"
// 												name="passwordLogin"
// 												value={password}
// 												onChange={async (e) => setPassword(e.target.value)}
// 												style={{ paddingRight: "40px" }} // cria espaço para o ícone olho
// 											/>
// 											<i
// 												className={`zmdi ${
// 													showPassword ? "zmdi-eye-off" : "zmdi-eye"
// 												}`}
// 												style={{
// 													fontSize: "18px",
// 													cursor: "pointer",
// 													position: "absolute",
// 													right: "12px",
// 													top: "50%",
// 													transform: "translateY(-50%)",
// 													color: "#555",
// 													zIndex: 10, // garante que nunca fica atrás do input
// 													pointerEvents: "auto", // permite clicar mesmo em cima do input
// 												}}
// 												onClick={() => setShowPassword(!showPassword)}
// 												title={
// 													showPassword ? "Ocultar password" : "Mostrar password"
// 												}
// 											/>
// 										</div>
// 										<div className="form-group form-check px-0 mx-0 align-items-center">
// 											<a
// 												href="/account/forgot-password"
// 												className="float-right"
// 											>
// 												Forgot password
// 											</a>
// 										</div>
// 										<button
// 											type="submit"
// 											className="btn btn-primary sign-fbtn mt-3 "
// 											onClick={onSubmit}
// 											style={{
// 												background: "#e78e4b",
// 												border: "2px solid #e78e4b",
// 												borderRadius: "8px",
// 												padding: "4px 10px", // menor altura
// 												cursor: "pointer",
// 												display: "inline-flex",
// 												alignItems: "center",
// 												justifyContent: "center",
// 												transition: "all 0.2s",
// 												outline: "none",
// 												boxShadow: "0 4px 6px rgba(0,0,0,0.15)",
// 												position: "relative",
// 												width: "100%",
// 												gap: "8px",
// 											}}
// 											onMouseOver={(e) => {
// 												e.currentTarget.style.background = "#EBB994";
// 												e.currentTarget.style.boxShadow =
// 													"0 6px 10px rgba(0,0,0,0.2)";
// 												e.currentTarget.style.transform = "translateY(-2px)";
// 											}}
// 											onMouseOut={(e) => {
// 												e.currentTarget.style.background = "#e78e4b";
// 												e.currentTarget.style.boxShadow =
// 													"0 4px 6px rgba(0,0,0,0.15)";
// 												e.currentTarget.style.transform = "translateY(0)";
// 											}}
// 											onMouseDown={(e) => {
// 												e.currentTarget.style.transform =
// 													"translateY(1px) scale(0.95)";
// 												e.currentTarget.style.boxShadow =
// 													"0 2px 4px rgba(0,0,0,0.1)";
// 											}}
// 											onMouseUp={(e) => {
// 												e.currentTarget.style.transform =
// 													"translateY(-2px) scale(1)";
// 												e.currentTarget.style.boxShadow =
// 													"0 6px 10px rgba(0,0,0,0.2)";
// 											}}
// 										>
// 											Login
// 											{isLoading && (
// 												<div
// 													style={{
// 														animation: "spinner-border 1000ms infinite linear",
// 														width: "fit-content",
// 														float: "right",
// 														fontSize: "18px",
// 													}}
// 												>
// 													<i className="zmdi zmdi-refresh"></i>
// 												</div>
// 											)}
// 										</button>
// 									</form>
// 								</>
// 							)}
// 							{(tempSessionToken?.length ?? 0) > 0 && (
// 								<>
// 									<form onSubmit={validate2fa}>
// 										<h3
// 											className="form-heading"
// 											style={{ textAlign: "center" }}
// 										>
// 											Multi-factor Security
// 										</h3>
// 										<div style={{ display: "flex", margin: "1.5rem" }}>
// 											<div style={{ flex: "1" }}></div>
// 											<a
// 												target="_blacnk"
// 												href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en_US"
// 											>
// 												<div style={{ display: "flex" }}>
// 													<img
// 														src="https://upload.wikimedia.org/wikipedia/commons/8/84/Google_Authenticator_%28April_2023%29.svg"
// 														width={30}
// 													/>
// 													<h5 style={{ fontSize: "25px", margin: "0" }}>
// 														Google Authenticator
// 													</h5>
// 												</div>
// 											</a>
// 											<i
// 												class="zmdi zmdi-help"
// 												style={{
// 													fontSize: "20px",
// 													padding: "5px",
// 													marginLeft: "2px",
// 												}}
// 												onClick={() => {
// 													setShow2faHelp((e) => !e);
// 												}}
// 											></i>
// 											<div style={{ flex: "1" }}></div>
// 										</div>
// 										<div style={{ display: show2faHelp ? "block" : "none" }}>
// 											<div>
// 												<label>
// 													1 - Install Google Authenticator App to continue:
// 												</label>
// 											</div>
// 											<div
// 												style={{
// 													display: "flex",
// 													margin: "0.5rem",
// 													fontSize: "23px",
// 												}}
// 											>
// 												<div style={{ flex: "1" }}></div>
// 												<a
// 													target="_blank"
// 													rel="noreferrer"
// 													href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en_US"
// 												>
// 													<div style={{ display: "flex" }}>
// 														<i
// 															class="zmdi zmdi-google-play"
// 															style={{ margin: "5px" }}
// 														></i>
// 														<div>Google Play</div>
// 													</div>
// 												</a>
// 												<div style={{ flex: "1" }}></div>
// 												<a
// 													target="_blank"
// 													rel="noreferrer"
// 													href="https://apps.apple.com/us/app/google-authenticator/id388497605"
// 												>
// 													<div style={{ display: "flex" }}>
// 														<i
// 															class="zmdi zmdi-apple"
// 															style={{ margin: "5px" }}
// 														></i>
// 														<div>App Store</div>
// 													</div>
// 												</a>
// 												<div style={{ flex: "1" }}></div>
// 											</div>
// 											<div>
// 												<label>2 - Register MedApp Centro2s in app:</label>
// 												<div
// 													style={{ display: "flex", cursor: "pointer" }}
// 													onClick={send2faCodeEmail}
// 												>
// 													<div style={{ flex: "1" }}></div>
// 													<i
// 														class="zmdi zmdi-email"
// 														style={{ margin: "5px" }}
// 													></i>
// 													<label>Send code to my email</label>
// 													<div style={{ flex: "1" }}></div>
// 												</div>
// 											</div>
// 											<div>
// 												<label>
// 													3 - Success! now you can insert the code bellow.
// 												</label>
// 											</div>
// 										</div>

// 										<div className="input-group mb-4">
// 											<input
// 												type="text"
// 												className="form-control"
// 												placeholder="Code"
// 												id="twofaCodeLogin"
// 												name="twofaCodeLogin"
// 												onChange={async (e) => setTemp2faKey(e.target.value)}
// 											/>
// 										</div>
// 										<button
// 											type="submit"
// 											className="btn btn-primary sign-fbtn mt-3 "
// 											onClick={validate2fa}
// 											style={{ width: "100%" }}
// 										>
// 											Confirm
// 											{isLoading && (
// 												<div
// 													style={{
// 														animation: "spinner-border 1000ms infinite linear",
// 														width: "fit-content",
// 														float: "right",
// 													}}
// 												>
// 													<i className="zmdi zmdi-refresh"></i>
// 												</div>
// 											)}
// 										</button>
// 									</form>
// 								</>
// 							)}
// 						</div>
// 					</div>
// 				</div>
// 			</div>
// 		</div>
// 	);
// };

// export default Login;

const Login = () => {
	const dispatch = useDispatch();
	const history = useHistory();

	const [username, setUsername] = React.useState("");
	const [password, setPassword] = React.useState("");
	const [tempSessionToken, setTempSessionToken] = React.useState("");
	const [temp2faKey, setTemp2faKey] = React.useState("");
	const [show2faHelp, setShow2faHelp] = React.useState(false);

	const [isLoginLoading, setIsLoginLoading] = React.useState(false);
	const [is2faLoading, setIs2faLoading] = React.useState(false);
	const [loginError, setLoginError] = React.useState("");
	const [twoFaError, setTwoFaError] = React.useState("");

	const [showPassword, setShowPassword] = React.useState(false);
	const [resendCooldown, setResendCooldown] = React.useState(0);
	const [resendStatus, setResendStatus] = React.useState(""); // "sent" | "error" | ""
	const [isResending, setIsResending] = React.useState(false);
	const [capsLockOn, setCapsLockOn] = React.useState(false);

	const startSafetyTimeout = (setLoadingFn, setErrorFn, message) => {
		const timeoutId = setTimeout(() => {
			setLoadingFn(false);
			setErrorFn(message);
		}, 15000);
		return timeoutId;
	};

	const validateLogin = () => {
		if (!username?.trim() || !password?.trim()) {
			setLoginError("Please enter your username and password.");
			return false;
		}
		return true;
	};

	const validate2faInput = () => {
		if (!temp2faKey?.trim()) {
			setTwoFaError("Please enter the verification code.");
			return false;
		}
		return true;
	};

	const resend2faCode = async () => {
		if (!tempSessionToken || resendCooldown > 0 || isResending) return;

		setResendStatus("");
		setIsResending(true);

		try {
			await xhrApiSendAuth2faSetupEmail(tempSessionToken);
			setResendStatus("sent");
			setResendCooldown(30);
		} catch (err) {
			setResendStatus("error");
		} finally {
			setIsResending(false);
		}
	};

	const validate2fa = async (e) => {
		e.preventDefault();
		setTwoFaError("");
		if (!validate2faInput()) return;

		if (is2faLoading) return;
		setIs2faLoading(true);

		const safetyId = startSafetyTimeout(
			setIs2faLoading,
			setTwoFaError,
			"Verification is taking too long. Please try again.",
		);

		try {
			const res = await xhrApiValidateAuth2faKey(tempSessionToken, temp2faKey);

			// ✅ FIX: se NÃO vem token, então é inválido
			if (!res?.result?.data) {
				clearTimeout(safetyId);
				setIs2faLoading(false);
				setTwoFaError("Invalid code. Please try again.");
				return;
			}

			dispatch(
				LoginTwoFactorAction({
					token: res?.result?.data,
					tokenExpireDate: res?.result?.expireDate,
					callback: () => {
						clearTimeout(safetyId);
						setIs2faLoading(false);

						if (history.length > 0) history.goBack();
						else window.location.reload();
					},
				}),
			);
		} catch (err) {
			clearTimeout(safetyId);
			setIs2faLoading(false);
			setTwoFaError("Failed to validate code. Please try again.");
		}
	};

	const onSubmit = async (e) => {
		e.preventDefault();
		setLoginError("");
		if (!validateLogin()) return;

		if (isLoginLoading) return;
		setIsLoginLoading(true);

		const safetyId = startSafetyTimeout(
			setIsLoginLoading,
			setLoginError,
			"Login is taking too long. Please try again.",
		);

		let callbackCalled = false;

		try {
			await dispatch(
				LoginAction({
					userName: username,
					password,
					history,
					callback: (data) => {
						callbackCalled = true;
						clearTimeout(safetyId);
						setIsLoginLoading(false);

						if (data?.error) {
							setLoginError(data?.error?.message || "Invalid credentials.");
							return;
						}

						if (data?.result?.status === "RequireEmailConfirm") {
							history.push("/account/email-confirm");
							return;
						}

						if (data?.result?.status === "Require2fa") {
							setTempSessionToken(data?.result?.data);
							return;
						}

						if (!data?.result) {
							setLoginError("Unexpected response. Please try again.");
						}
					},
				}),
			);
		} catch (err) {
			clearTimeout(safetyId);
			setLoginError("Something went wrong. Please try again.");
		} finally {
			setTimeout(() => {
				if (!callbackCalled) {
					clearTimeout(safetyId);
					setIsLoginLoading(false);
					setLoginError("Invalid credentials.");
				}
			}, 1000);
		}
	};

	React.useEffect(() => {
		if (resendCooldown <= 0) return;
		const interval = setInterval(
			() => setResendCooldown((prev) => prev - 1),
			1000,
		);
		return () => clearInterval(interval);
	}, [resendCooldown]);

	React.useEffect(() => {
		if (loginError) setIsLoginLoading(false);
	}, [loginError]);

	return (
		<div>
			<div className="prospect-combo">
				<div className="container-fluid p-0">
					<div className="row m-0">
						<div className="col-xl-3 col-lg-4 col-md-4 d-none d-md-block forgetpwd-left p-0">
							<LoginSliderPanel
								promos={LOGIN_SLIDER}
								title={{ white: "Ref", accent: "App" }}
								subtitle="Reset your password securely and regain access."
								compact
							/>
						</div>

						<div className="col-xl-8 col-lg-7 col-md-6 col-sm-12 form-element px-sm-5 pt-sm-5 d-flex flex-column align-content-center justify-content-center form-container d-flex align-items-center justify-content-center">
							{(tempSessionToken?.length ?? 0) === 0 && (
								<div className="login-card">
									<div className="login-card-header">
										<h3 className="form-heading mb-2">Welcome back</h3>
										<p className="form-subheading mb-4">
											Sign in to manage your account.
										</p>
									</div>

									{loginError && (
										<div className="login-alert">
											<i className="zmdi zmdi-alert-circle" />
											<span>{loginError}</span>
										</div>
									)}

									<form onSubmit={onSubmit}>
										<div className="input-group mb-4">
											<div className="input-group-prepend">
												<span className="input-group-text">
													<img src={UserIcon} alt="usericon" />
												</span>
											</div>
											<input
												type="text"
												className="form-control"
												placeholder="User name"
												id="userNameLogin"
												name="usernameLogin"
												onChange={(e) => {
													setUsername(e.target.value);
													if (loginError) setLoginError("");
												}}
											/>
										</div>

										<div className="input-group mb-4 password-field">
											<div className="input-group-prepend">
												<span className="input-group-text">
													<img src={PwdIcon} alt="pwdicon" />
												</span>
											</div>

											<input
												type={showPassword ? "text" : "password"}
												className="form-control"
												placeholder="Enter password"
												id="passwordLogin"
												name="passwordLogin"
												value={password}
												onChange={(e) => {
													setPassword(e.target.value);
													if (loginError) setLoginError("");
												}}
												onKeyUp={(e) =>
													setCapsLockOn(e.getModifierState("CapsLock"))
												}
												onKeyDown={(e) =>
													setCapsLockOn(e.getModifierState("CapsLock"))
												}
											/>

											<button
												type="button"
												className="password-toggle-btn"
												onClick={() => setShowPassword((prev) => !prev)}
												title={
													showPassword ? "Ocultar password" : "Mostrar password"
												}
												aria-label={
													showPassword ? "Ocultar password" : "Mostrar password"
												}
											>
												<i
													className={`zmdi ${showPassword ? "zmdi-eye-off" : "zmdi-eye"}`}
												/>
											</button>
										</div>

										{capsLockOn && (
											<div className="capslock-warning">
												<i className="zmdi zmdi-alert-circle" />
												Caps Lock is ON
											</div>
										)}

										<div className="login-meta-row">
											<a href="/account/forgot-password" className="login-link">
												Forgot password?
											</a>
										</div>

										<button
											type="submit"
											className="btn btn-primary sign-fbtn mt-3 login-submit-btn"
											disabled={isLoginLoading}
										>
											Login
											{isLoginLoading && (
												<span className="login-spinner" aria-label="loading">
													<i className="zmdi zmdi-refresh"></i>
												</span>
											)}
										</button>
									</form>

									{isLoginLoading && (
										<div className="card-loading-overlay">
											<div className="card-loading-spinner">
												<i className="zmdi zmdi-refresh" />
												<div>Signing in...</div>
											</div>
										</div>
									)}
								</div>
							)}

							{(tempSessionToken?.length ?? 0) > 0 && (
								<div className="login-card">
									<div className="login-card-header">
										<h3 className="form-heading mb-2">Multi-factor Security</h3>
										<p className="form-subheading mb-4">
											Enter the verification code from your authenticator app.
										</p>
									</div>

									{twoFaError && (
										<div className="login-alert">
											<i className="zmdi zmdi-alert-circle" />
											<span>{twoFaError}</span>
										</div>
									)}

									<form onSubmit={validate2fa}>
										<div style={{ display: "flex", margin: "1.5rem" }}>
											<div style={{ flex: "1" }}></div>
											<a
												target="_blank"
												rel="noreferrer"
												href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en_US"
											>
												<div style={{ display: "flex" }}>
													<img
														src="https://upload.wikimedia.org/wikipedia/commons/8/84/Google_Authenticator_%28April_2023%29.svg"
														width={30}
														alt="Google Authenticator"
													/>
													<h5 style={{ fontSize: "25px", margin: "0" }}>
														Google Authenticator
													</h5>
												</div>
											</a>

											<i
												className="zmdi zmdi-help"
												style={{
													fontSize: "20px",
													padding: "5px",
													marginLeft: "2px",
												}}
												onClick={() => setShow2faHelp((prev) => !prev)}
											></i>
											<div style={{ flex: "1" }}></div>
										</div>

										<div style={{ display: show2faHelp ? "block" : "none" }}>
											<div>
												<label>
													1 - Install Google Authenticator App to continue:
												</label>
											</div>
											<div
												style={{
													display: "flex",
													margin: "0.5rem",
													fontSize: "23px",
												}}
											>
												<div style={{ flex: "1" }}></div>
												<a
													target="_blank"
													rel="noreferrer"
													href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en_US"
												>
													<div style={{ display: "flex" }}>
														<i
															className="zmdi zmdi-google-play"
															style={{ margin: "5px" }}
														></i>
														<div>Google Play</div>
													</div>
												</a>
												<div style={{ flex: "1" }}></div>
												<a
													target="_blank"
													rel="noreferrer"
													href="https://apps.apple.com/us/app/google-authenticator/id388497605"
												>
													<div style={{ display: "flex" }}>
														<i
															className="zmdi zmdi-apple"
															style={{ margin: "5px" }}
														></i>
														<div>App Store</div>
													</div>
												</a>
												<div style={{ flex: "1" }}></div>
											</div>

											<div>
												<label>2 - Send setup code to your email:</label>
												<div
													style={{ display: "flex", cursor: "pointer" }}
													onClick={resend2faCode}
												>
													<div style={{ flex: "1" }}></div>
													<i
														className="zmdi zmdi-email"
														style={{ margin: "5px" }}
													></i>
													<label>Send code to my email</label>
													<div style={{ flex: "1" }}></div>
												</div>
											</div>
										</div>

										<div className="input-group mb-4">
											<input
												type="text"
												className="form-control"
												placeholder="Code"
												id="twofaCodeLogin"
												name="twofaCodeLogin"
												onChange={(e) => {
													setTemp2faKey(e.target.value);
													if (twoFaError) setTwoFaError("");
												}}
											/>
										</div>

										<div className="twofa-actions">
											<button
												type="button"
												className="twofa-resend-btn"
												onClick={resend2faCode}
												disabled={resendCooldown > 0 || isResending}
											>
												{isResending
													? "Sending..."
													: resendCooldown > 0
														? `Resend available in ${resendCooldown}s`
														: "Resend code"}
											</button>

											{resendStatus === "sent" && (
												<span className="twofa-status success">Code sent!</span>
											)}
											{resendStatus === "error" && (
												<span className="twofa-status error">
													Could not send. Try again.
												</span>
											)}
										</div>

										<button
											type="submit"
											className="btn btn-primary sign-fbtn mt-3 login-submit-btn"
											disabled={is2faLoading}
										>
											Confirm
											{is2faLoading && (
												<span className="login-spinner" aria-label="loading">
													<i className="zmdi zmdi-refresh"></i>
												</span>
											)}
										</button>
									</form>

									{is2faLoading && (
										<div className="card-loading-overlay">
											<div className="card-loading-spinner">
												<i className="zmdi zmdi-refresh" />
												<div>Validating...</div>
											</div>
										</div>
									)}
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Login;
